import React, {useEffect, useRef} from 'react'
import {useRecoilValue, useSetRecoilState} from "recoil";
import {alert_show_state, alert_state} from "../../../common/atom/dialog";
import styled from "@emotion/styled";

const Container = styled.div`
    position: absolute;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
`

const Box = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 2.25rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: 80%;
    background: white;
    border-radius: 1rem;    
    min-height: 165px;
    height: auto;
`

const Title = styled.h1`
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5rem;
    text-align: center;
    color: ${({theme}) => theme.primary.bk02};
    white-space: pre-wrap;
    margin: 0;

    strong {
        color: ${({theme}) => theme.primary.bl01};
    }
`

const Description = styled.p`
    color:  ${({theme}) => theme.primary.bk01};
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 500;
    line-height: 99%; /* 11.88px */
    letter-spacing: -0.24px;
    text-align: center;
    width: max-content;
    margin: 0;
`

const ButtonBox = styled.div`
    display: flex;
    gap: 6px;
    width: 100%;
`

const Button = styled.button`
    min-width: 47%;
    height: 50px;
    border-radius: 0.75rem;
    background-color: ${({theme}) => theme.button.background};
    color: ${({theme}) => theme.button.text};
    border: none;
    font-weight: 500;
    font-size: 1rem;
    width: 100%;
    margin-top:  1.5rem;
    cursor: pointer;
`

const CancelBtn = styled(Button)`
    background-color: ${({theme}) => theme.button.disabled.background};
    color: ${({theme}) => theme.button.disabled.text};
`

export default function Alert() {
    const {title, message, confirm, cancel} = useRecoilValue(alert_state);
    const setShow = useSetRecoilState(alert_show_state);

    const ref = useRef<HTMLButtonElement>(null);

    const onConfirm = () => {
        setShow(false);
        if (confirm) confirm();
        
    }

    const onCancel = () => {
        setShow(false);
        if (cancel) cancel();
    }

    useEffect(() => {
        ref.current?.focus();
    }, []);

    return (
        <Container role="alert" tabIndex={0}>
            <Box>
                <Title tabIndex={0} role='text'>{title}</Title>
                <Description tabIndex={0} role='text'>{message}</Description>
                <ButtonBox>
                    {cancel && <CancelBtn onClick={onCancel} role="button">취소</CancelBtn>}
                    <Button ref={ref} onClick={onConfirm} role="button">확인</Button>
                </ButtonBox>
            </Box>
        </Container>
    )
}

